export const l = {
    hebewallet: "用于比特币，以太坊，Ripple，Litecoin，Stellar和90多个主链的安全加密区块链货币钱包",
    fhead: {
        'zh-CN': '中文',
        'en-US': 'English',
        block: '区块浏览器',
        blocks: '区块',
        peers: '节点',
        generators: '锻造池',
        peersMap: '节点地图',
        peers3d: '3D节点地图',
        prompt: {
            title: '提示',
            txt: '请输入账号地址/区块高度',
            confirm: '确定',
            cancel: '取消'
        },
        peer1:"节点操作",
        peer2:"抵押节点"
    },
    accountCount: '账号总数',
    assetCount: '资产总数',
    currencyCount: '货币总数',
    aliasCount: '别名总数',
    block: '区块',
    senderRS: '发送地址',
    recipientRS: '接收地址',
    amountNQT: '数量',
    feeNQT: '手续费',
    height: '高度',
    timestamp: '日期',
    totalAmountNQT: '转账数量',
    transactionsLength: '交易数',
    generatorRS: '出块者',
    generators: '锻造池',
    generators1: '锻造人数',
    generators2: '非全部锻造人数',
    lessorRS: '出租地址',
    guaranteedBalanceNQT: '出租数量',
    accountRS: '账户地址',
    effectiveBalance: '锻造数量',
    lessorSum: '出租人数量',
    lessorTimes: '出块时间',
    deadline: '出块倒计时间',
    home: '首页',
    hour: '',
    peers: {
        txt1: "当前节点对等网络",
        txt2: "非全部网络节点",
        address: 'IP地址',
        version: '客户端版本',
        platform: '平台/所有者',
        services: '服务',
        lastUpdated: '最近更新时间'
    },
    account: {
        addr: '账号地址',
        this: '本账号',
        id: '账号id',
        name: '账号名',
        publicKey: '账号公钥',
        balanceNQT: '账号余额',
        lessorsSum: '承租数量',
        forgedBalanceNQT: '锻造收益',
        blockCount: '锻造块数',
        description: '账号描述',
        currentLesseeTitle: '出租信息',
        currentLessee: '承租人账号id',
        currentLesseeRS: '承租人账号地址',
        currentLeasingHeightFrom: '出租高度',
        currentLeasingHeightTo: '到期高度',
        nextLessee: '下一个承租人账号id',
        nextLesseeRS: '下一个承租人账号地址',
        nextLeasingHeightFrom: '下一个出租高度',
        nextLeasingHeightTo: '下一个到期高度',
        add15: '再加载15条信息',
        transaction: '交易信息列表',
        date: '时间',
        lessorsTitle: '出组人列表',
        blockCountTitle: '锻造区块列表',
        pow: 'POW锻造区块列表',
        index: {
            title: '所有账号',
            title1: '账号列表',
            BALANCE: '持币数',
            FORGED_BALANCE: '锻造收益',
            DESCRIPTION: '描述'
        }
    },
    alias: {
        title: '所有别名',
        title1: '别名列表',
        search: '请输入搜索别名',
        ALIAS_NAME: '名称',
        accountRS: '所有者'
    },
    asset: {
        title: '所有资产',
        title1: '资产列表',
        search: '请输入搜索资产',
        account: '资产ID',
        NAME: '资产名',
        INITIAL_QUANTITY: '初始数量',
        QUANTITY: '总量',
        DECIMALS: '小数点',
        accountRS: '发行者'

    },
    currency: {
        title: "所有货币",
        title1: '货币列表',
        search: '请输入搜索货币',
        account: '货币id',
        NAME: '货币名',
        MAX_SUPPLY: '总量',
        accountRS: '发行者'
    },
    blocks: {
        title: '所有区块',
        totalAmountNQT: '总转账数量',
        date: '时间'
    },
    blockIndex: {
        title: '所有区块',
        title1: '区块高度',
        title2: '下一个区块',
        title3: '上一个区块',
        transactions: '交易信息列表',
        height: '区块高度',
        date: '区块时间',
        generatorRS: '区块锻造者',
        length: '区块交易数',
        totalAmountNQT: '总转账数量',
        totalFeeNQT: '区块手续费'
    },
    transaction: {
        height: "高度",
        block: "区块",
        sender: "发送者id",
        senderRS: "发送者地址",
        amountNQT: "发送金额",
        feeNQT: "手续费",
        recipient: "接收者id",
        recipientRS: "接收者地址",
        timestamp: "时间",
        confirmations: "确定区块",
        attachment: "附件"
    },
    peer: {
        txt: "抵押节点",
        txt1: "新增节点",
        txt2: "ip地址",
        txt3: "节点拥有者",
        txt4: "距离发放日期",
        txt5: "奖励币数",
        txt6: "抵押",
        txt7: "服务器节点",
        txt8: "最近在线时间",
        txt9: "请使用http://block.hebeblock.com域名，带上https无法正常获取数据",
        txt10: "节点类型",
        txt11: "请选择节点类型",
        txt12: "服务器节点",
        txt13: "本地节点",
        txt14: "节点ip",
        txt15: "请输入远程节点ip",
        txt16: "检查节点",
        txt17: "点击检查",
        txt18: "节点ip",
        txt19: "Hebe地址",
        txt20: "最后时间",
        txt21: "立即创建",
        txt22: "取消",
        txt23: "提示",
        txt24: "确定",
        txt25: "获取信息错误，本地节点还未与远程节点有关联，请等待",
        txt26: "远程服务器未打开8082端口",
        txt27: "远程服务器请求错误",
        txt28: "获取信息错误，请检查你本地节点是否启动",
        txt29: "获取信息错误，远程节点出现了问题",

    }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js